import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface EmptyStateMessageProps {
    message: string;
    icon?: React.ReactNode;
    align?: 'left' | 'center';
    maxWidth?: number | string;
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
    message,
    icon = <InfoIcon color="info" sx={{ mr: 1 }} />,
}) => {
    return (
        <Box
            display="flex"
            justifyContent="left"
            alignItems="left"
            mx="auto"
            px={2}
            textAlign="left"
        >
            {icon}
            <Typography
                variant="h5"
                fontWeight="medium"
                color="text.secondary"
            >
                {message}
            </Typography>
        </Box>
    );
};

export default EmptyStateMessage;
